import $ from "jquery";

let image = "";

const onSuccess = () => {
  $(".js_landing_error, .js_form_root").addClass("hide");
  $(".js_success").removeClass("hide");
  $(".js_landing_file").removeClass("error");
};

const submitForm = () => {
  const locale = $("html").attr("lang");
  const fileInput = $(".js_landing_file");

  $.ajax({
    url: $(".js_landing_form").attr("action"),
    type: "POST",
    headers: {
      "Accept-Language": locale,
    },
    data: {
      name: $(".js_landing_name").val(),
      phone: $(".js_landing_phone").val().replace("+", "").replaceAll(" ", ""),
      email: $(".js_landing_email").val(),
      child: $(".js_landing_child").val(),
      image,
    },
    success: onSuccess,
    error: ({ responseJSON, status }) => {
      if (responseJSON) {
        Object.keys(responseJSON.errors).forEach((name) => {
          if (name === "image") {
            fileInput.addClass("error");
            // $(".js_landing_file_error").removeClass("hide");
          } else {
            const htmlError = $(
              `.js_landing_form input[name=${name}]`
            ).siblings(".js_landing_error");
            htmlError
              .removeClass("hide")
              .text(responseJSON.errors[name].join(", "));
          }
        });
      }
      if (status === 413) {
        $(".js_landing_uploaded").addClass("hide");
        $(".js_landing_file_error").removeClass("hide");
      }
    },
    done: () => {
      console.log("done");
    },
  });
};

export const initLandingForm = () => {
  const form = $(".js_landing_form");

  if (form.length > 0) {
    form.on("submit", (e) => {
      e.preventDefault();
      submitForm();
    });

    $(".js_landing_error").on("click", function () {
      const input = $(this).siblings("input");
      $(this).addClass("hide");
      input.focus();
    });

    $(".js_landing_file").on("change", () => {
      $(".js_landing_file").removeClass("error");
      const reader = new FileReader();
      const fileInput = document.querySelector(".js_landing_file").files[0];

      reader.onload = () => {
        image = reader.result;
      };
      if (fileInput) {
        reader.readAsDataURL(fileInput);
        $(".js_landing_uploaded").removeClass("hide");
        $(".js_landing_file_error").addClass("hide");
      } else {
        $(".js_landing_uploaded").addClass("hide");
      }
    });

    window.maskedInput();
  }
};
